import { ClientDataType } from 'modules/queryBuilder/types';

export enum GoalEventType {
  CustomEvent = 'CustomEvent',
  Purchase = 'Purchase',
  System = 'System',
}

export enum GoalAttributionMode {
  NotSet = 'NotSet',
  ExplicitlySet = 'ExplicitlySet',
  AttributionPeriod = 'AttributionPeriod',
}

export type GoalMetricDefinition = {
  metric: string;
  enumName: string;
  associatedMetric: string | null;
  metricLabel: string;
  associatedMetricLabel: string | null;
  countLabel: string;
};

export type Goal = {
  id: string;
  projectId: number;
  name: string;
  createdAt: string;
  updatedAt: string;
  createdBy: string;
  updatedBy: string;
  isArchived: boolean;
  eventName: ClientDataType | string;
  eventType: GoalEventType;
  attributionMode: GoalAttributionMode;
  attributionWindowHours: number | null;
  campaignLabelIds: number[];
  messageTypeIds: number[];
  metricDefinition: GoalMetricDefinition;
};

export type GoalsTableColumn = {
  id: string;
  label: string;
  isSortable?: boolean;
};

// TODO: give this a more intuitive name once we know what its meant to do
export enum GoalStatus {
  ALL = 'All',
  ACTIVE = 'Active',
  ARCHIVED = 'Archived',
  DRAFT = 'Draft',
}

export type GoalsTabFilter = {
  id: GoalStatus;
  label: string;
  sortOrder: number;
  filters: GoalStatus[];
  query?: GoalStatus[];
};
